import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '@ascschool/core/auth';
import { BtnOptionExtend, Nztheme, Nztype } from '@ascschool/interface/button/btn-option-extend';
import { JUser } from '@ascschool/interface/user';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { MailService } from '@ascschool/services/mail/mail.service';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { PopUpComposeComponent } from '../pop-up-compose/pop-up-compose.component';
@Component({
  selector: 'app-mail-detail',
  templateUrl: './mail-detail.component.html',
  styleUrls: ['./mail-detail.component.scss']
})
export class MailDetailComponent implements OnInit {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  titlePopup: string;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  userInfo: JUser;
  outboxId: number;
  tag = 'quantrong';
  fileList: NzUploadFile[] = [];
  mailDetail: any = [];
  @Input() value;
  @Input() mode;
  constructor(
    private modal: NzModalRef,
    private service: MailService,
    private modalService: NzModalService,
    public _authService: AuthService,
  ) {
  }
  pageOptBtn_1: BtnOptionExtend[]=[
    new BtnOptionExtend('Trả lời',null,this.openReply.bind(this),Nztype.PRIMARY,false,Nztheme.OUTLINE,null,null,'fa fa-reply'),
    new BtnOptionExtend('Trả lời tất cả',null,this.openReplyAll.bind(this),null,false,Nztheme.OUTLINE, null, null, 'fa fa-reply-all')
  ];
  pageOptBtn_2: BtnOptionExtend[]=[
    new BtnOptionExtend('Chuyển tiếp',null,this.openForward.bind(this),null,false,Nztheme.OUTLINE, null, null, 'fa fa-arrow-right')
  ];
  pageOptBtn_3: BtnOptionExtend[]=[
    new BtnOptionExtend('Xóa','delete',this.deleteMail.bind(this),Nztype.PRIMARY,true,Nztheme.OUTLINE)
  ];
  ngOnInit() {
    if(this.mode === 'inbox' || this.mode === 'deleted'){
      this.getDetailInboxMail();
    }else(this.mode === 'outbox')
    {
      this.getDetailOutboxMail();
    }
    this.userInfo = this._authService.getUserInfo();
  }
  getCountInboxUnRead(){
    this.service.getCountUnread().subscribe((res: number)=>{
      this.service.refreshCountInboxUnread(res);
    });
  }
  getDetailInboxMail(){
    this.service.getMailInboxById(this.value.id).subscribe((res)=>{
      this.mailDetail = res;
      this.outboxId = res.outboxId;
      this.getMailfile(this.outboxId);
      this.getCountInboxUnRead();
    });
  }
  getDetailOutboxMail(){
    this.service.getMailOutboxById(this.value.id).subscribe((res)=>{
      this.mailDetail = res;
      this.outboxId = res.id;
      this.getMailfile(this.outboxId);
    });
  }
  downloadfile = (file: any) => {
    this.service.getDownloadUrl(file.uid).subscribe((response) => {
      var a = document.createElement('a');
      a.href = response.url;
      a.target = '_blank';
      a.download = file.name;
      document.body.append(a);
      a.click();
      a.remove();
  });
  }
  close(){
    this.modal.destroy(true);
  }
  getMailfile(id: number){
    this.service.getListFiles(id).subscribe((res)=>{
      this.fileList = res.result.map(x => ({
        uid : x.id,
        name : x.fileName,
        status : 'done'
      }));
    });
  }
  openReply(){
    this.isResizdePopup = false;
    this.titlePopup = 'Trả lời';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopUpComposeComponent,
      nzStyle: { top: '40px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzWidth: 1200,
      nzComponentParams: {
        mode: 'reply',
        id: this.value.id,
        data: this.mailDetail,
        filesRes: this.fileList,
        type: this.mode,
      },
    });
  }
  openReplyAll(){
    this.isResizdePopup = false;
    this.titlePopup = 'Trả lời tất cả';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopUpComposeComponent,
      nzStyle: { top: '40px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzWidth: 1200,
      nzComponentParams: {
        mode: 'reply-all',
        id: this.value.id,
        data: this.mailDetail,
        filesRes: this.fileList,
        type: this.mode,
      },
    });
  }
  openForward(){
    this.isResizdePopup = false;
    this.titlePopup = 'Chuyển tiếp';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopUpComposeComponent,
      nzStyle: { top: '40px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzWidth: 1200,
      nzComponentParams: {
        mode: 'forward',
        id: this.value.id,
        data: this.mailDetail,
        filesRes: this.fileList,
        type: this.mode,
      },
    });
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  deleteMail(){
    this.isResizdePopup = false;
    this.titlePopup= 'Xóa thư';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: ConfirmComponent,
      nzComponentParams: {
        description: this.mailDetail.subject
      },
      nzStyle: { top: '20px' },
      nzMaskClosable: false
    });
    this.dialogRef.afterClose.subscribe((result) => {
      if (this.value.source === "Inbox" && result === true) {
        this.service.deleteMailInbox(this.value.id).subscribe((res: any) => {
          this.modal.close(true);
        });
      }else if(this.value.source === "Outbox" && result === true){
        this.service.deleteMailOutbox(this.value.id).subscribe((res: any) => {
          this.modal.close(true);
        });
      }
    });
  }
  handlerResizePopup(){
    this.isResizdePopup = !this.isResizdePopup;
    let width = 1200;
    let height = this.caculateHeightPopup(window.innerHeight) + 'px';
    let top = 30;
    if(this.isResizdePopup === true){
      width = window.innerWidth;
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.dialogRef.updateConfig({
      nzWidth: width,
      nzStyle: {
        top: top + 'px',
      },
      nzBodyStyle: {
        overflow: 'auto',
        height: height,
      }
    });
  }
}
